













































import { Component, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import PageNames from '@/router/PageNames';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import JobWorkerStatus from '@/components/JobWorkers/Display/JobWorkerStatus.vue';
import OpenEntityInNewWindowBtn from '../Shared/OpenEntityInNewWindowBtn.vue';

@Component({
  name: 'JobWorkersList',
  components: { JobWorkerStatus }
})
export default class extends GiganautVue {
    
    
    async beforeMount() {
       await WorkerDetailsModule.getJobs();
    }

    async navigateToJob(jobId: string) {
        this.$router.push({ name: PageNames.AgencyJobDetails, params: { jobid: jobId } });
    }
    
    get loading() {
        return WorkerDetailsModule.loadingJobs;
    }

    get jobs() {
        return WorkerDetailsModule.jobs;
    }

    private headers = [
        { text: 'Title', value: 'job.title' },
        { text: 'Location', value: 'location.brandName' },
        { text: 'Contact' },
        { text: 'Owner' },
        { text: 'Status' },
        { text: 'Actions' },
    ]
}
